var _rect, _ellipse, _path, _path2, _path3, _path4, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanaol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.282227,
    y: 0.908203,
    width: 64.3944,
    height: 64,
    rx: 20,
    fill: "#FECF0C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.9443,
    cy: 34.7004,
    rx: 5.25195,
    ry: 3.44141,
    fill: "#F56983",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6629 43.4713L21.1414 43.8531L21.6895 49.1238C21.8638 49.46 21.3314 52.1648 21.6895 52.2921C22.0477 52.4194 21.6558 49.2746 22.0031 49.1238L23.3018 47.4024L31.1559 48.6229C32.5627 48.0146 33.6515 46.8468 34.1644 45.4037L34.2361 45.202C35.1001 42.7715 34.0808 40.0749 31.8271 38.8234C30.3354 37.9955 28.5379 37.9401 27.0014 38.6707L26.4358 38.9397L26.1668 38.3741C25.4362 36.8376 24.0069 35.746 22.3274 35.4466C19.7895 34.9949 17.2968 36.4431 16.4329 38.8737L16.3612 39.0754C15.8482 40.5184 15.9556 42.1115 16.6629 43.4713Z",
    fill: "#F56983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75684 49.3991C9.54678 46.3569 16.1782 40.9528 20.3844 43.6744C24.5905 46.3959 20.4464 54.9936 17.8485 58.9523",
    stroke: "#880B67",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0024 53.3581C33.2125 50.3159 26.5811 44.9118 22.3749 47.6334C18.1688 50.3549 22.3129 58.9526 24.9108 62.9112",
    stroke: "#880B67",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9363 30.3139C25.7972 31.1661 25.8573 32.0367 26.1124 32.8648C26.3675 33.693 26.8115 34.4587 27.4134 35.1088C28.0153 35.7588 28.7606 36.2774 29.5973 36.6284C30.4341 36.9794 31.3421 37.1544 32.2581 37.1411C33.174 37.1279 34.0759 36.9267 34.9008 36.5516C35.7256 36.1765 36.4536 35.6365 37.034 34.9694C37.6143 34.3022 38.0331 33.524 38.261 32.6888C38.4889 31.8537 38.5205 30.9818 38.3535 30.134L36.6282 30.4349C36.7486 31.0465 36.7258 31.6755 36.5614 32.2779C36.397 32.8804 36.0949 33.4418 35.6763 33.9231C35.2576 34.4043 34.7325 34.7938 34.1374 35.0644C33.5424 35.335 32.8918 35.4801 32.2311 35.4897C31.5703 35.4993 30.9153 35.3731 30.3117 35.1198C29.7081 34.8666 29.1704 34.4925 28.7362 34.0236C28.302 33.5547 27.9818 33.0023 27.7977 32.4049C27.6137 31.8075 27.5704 31.1795 27.6707 30.5647L25.9363 30.3139Z",
    fill: "#880B67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75684,
    y: 5.84253,
    width: 23.1924,
    height: 23.4514,
    rx: 7,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0039,
    y: 5.84253,
    width: 23.1924,
    height: 23.4514,
    rx: 7,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.767,
    cy: 17.7689,
    r: 7.84265,
    fill: "#880B67"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8456,
    cy: 17.7689,
    r: 7.84265,
    fill: "#880B67"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6508,
    cy: 16.0448,
    r: 3.93494,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.701,
    cy: 16.0448,
    r: 3.93494,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5367,
    cy: 20.8732,
    r: 2.5553,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.587,
    cy: 20.8732,
    r: 2.5553,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1572,
    cy: 34.7004,
    rx: 5.25195,
    ry: 3.44141,
    fill: "#F56983",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanaol);
export default __webpack_public_path__ + "static/media/sanaol.f9f1bf26c75b18cd7dd35e3db62025e9.svg";
export { ForwardRef as ReactComponent };